import { useParams, useNavigate, useLocation } from "react-router-dom";
import { LOCALE_PREFIXES } from "@/i18n";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { locale } = useParams<{ locale: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const prefix = locale || "de";

  const current =
    LOCALE_PREFIXES.find((l) => l.prefix === prefix) ?? LOCALE_PREFIXES[0];

  const switchLocale = (newPrefix: string) => {
    const currentPath =
      location.pathname.replace(new RegExp(`^/${prefix}`), "") || "/";
    navigate(`/${newPrefix}${currentPath}`);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors py-2 px-1"
          aria-label="Land & Sprache wählen"
        >
          <Globe className="w-4 h-4" />
          <span className="hidden sm:inline">{current.flag}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {LOCALE_PREFIXES.map((lp) => (
          <DropdownMenuItem
            key={lp.prefix}
            onClick={() => switchLocale(lp.prefix)}
            className={lp.prefix === prefix ? "bg-accent" : ""}
          >
            <span className="mr-2">{lp.flag}</span>
            {lp.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
